import JobCard from '@web/components/JobCard';
import React from 'react';
import PropTypes from 'prop-types';
import ItemData from '@web/ui/containers/ItemData';
import {List} from 'antd';

JobsList.propTypes = {
  jobPaths: PropTypes.arrayOf(PropTypes.string).isRequired,
}

function JobsList(props) {
  return <List
    dataSource={props.jobPaths}
    renderItem={(jobPath) => {
      return <List.Item key={jobPath}>
        <ItemData
          dataField="job"
          preview={true}
          jobPath={jobPath}
          path={jobPath}
          component={JobCard}
        />
      </List.Item>
    }}
    locale={props.locale ||{
      emptyText: "No jobs found",
    }}
  />
}

export default JobsList;
